import React from "react";
import { Button, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

/**
 * Barra de atalhos de venda assistida (conteúdo enviado ao cliente).
 *
 * Cada ação descreve: { key, label, kind: "text"|"media", getText?(), getFile?(), caption?, helpText?, previewTitle? }.
 * Em vez de enviar direto, abre uma pré-visualização (onPreview) de como o cliente
 * vai receber. Um ícone de ajuda explica, ao passar o mouse, o que cada ação faz.
 */
export default function BPeAssistedActions({ t, assisted, actions, onPreview }) {
  const list = (actions || []).filter(Boolean);
  if (!assisted || !list.length) return null;

  const canSend = assisted.canSend;
  const isPhone = assisted.capability?.kind === "phone";
  // Sem canal de mensagem nem telefone: nada a oferecer.
  if (!canSend && !isPhone) return null;

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      alignItems="center"
      gap={0.5}
      sx={{ mb: 0.75, flexShrink: 0 }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700, mr: 0.25 }}>
        {t("bpeWizard.assist.title")}
      </Typography>
      {list.map((a) => (
        <Stack key={a.key} direction="row" alignItems="center" spacing={0.25}>
          <Button
            size="small"
            variant="outlined"
            startIcon={<VisibilityOutlinedIcon />}
            onClick={() => onPreview?.(a)}
            sx={{ textTransform: "none", py: 0.25 }}
          >
            {a.label}
          </Button>
          {a.helpText && (
            <Tooltip title={a.helpText} arrow>
              <IconButton size="small" sx={{ p: 0.25 }} aria-label={a.helpText}>
                <HelpOutlineIcon sx={{ fontSize: 16, color: "text.disabled" }} />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      ))}
    </Stack>
  );
}
